// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolFactory } from '@shared/commons/cache/DataCacheToolFactory';
import { TerceraChartUtils } from '../../TerceraChartUtils';
import { TerceraChartToolRenderer } from './TerceraChartToolRenderer';
import { ArrayUtils } from '@shared/utils/ArrayUtils';
import { ToolsCache } from '@shared/commons/cache/ToolsCache';
export class TerceraChartToolInstanceRenderer extends TerceraChartToolRenderer {
    constructor(chartID, chart) {
        super(chartID, chart, null);
        this.SupportDataConverter = true;
        this.SetClassName('TerceraChartToolInstanceRenderer');
    }
    AddTool(tool, e) {
        tool.WindowsNumber = this.WindowsNumber;
        ToolsCache.AddTool(tool, e);
        return true;
    }
    RemoveTool(toolView) {
        super.RemoveTool.call(this, toolView);
        const tV = this.GetToolViewByDataCacheTool(toolView.dataCacheTool);
        if (tV === null)
            return false;
        tV.Dispose();
        return ArrayUtils.RemoveElementFromArray(this.tools, tV);
    }
    ClearTools() {
        this.tools.length = 0;
    }
    DrawAllTools(gr, window, param) {
        for (const tool of this.tools) {
            tool.UpdateScreenPoints(window, this.chart.MainCashItemSeries);
            tool.Draw(gr, window, param);
        }
    }
    CloneTool(tool, ww) {
        const clonedDCTool = DataCacheToolFactory.Clone(tool.dataCacheTool);
        if (ww !== null) {
            TerceraChartUtils.ShiftTool(clonedDCTool, ww);
            // локальная тулза
            this.AddTool(clonedDCTool);
        }
    }
}
